/**
 * LeadWaChatDialog — Iter Feb 2026 R44.
 *
 * A modal popup that opens WhatsAppMiniInbox pre-focused on the lead's
 * phone. If no thread exists yet, the mini inbox itself shows the
 * "no conversation" hint pointing to the main WA Inbox for template send.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import WhatsAppMiniInbox from "./WhatsAppMiniInbox";
import { MessageCircle } from "lucide-react";

export default function LeadWaChatDialog({ lead, onClose }) {
  if (!lead) return null;
  return (
    <Dialog open onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-3xl rounded-none p-0">
        <DialogHeader className="border-b px-3 py-2">
          <DialogTitle className="flex items-center gap-2 text-sm">
            <MessageCircle className="w-4 h-4 text-emerald-600" />
            WhatsApp · {lead.name || lead.phone}
            <span className="text-[10px] text-muted-foreground font-normal ml-2">{lead.phone || "no phone"}</span>
          </DialogTitle>
        </DialogHeader>
        <div className="h-[540px]" data-testid="lead-wa-dialog">
          <WhatsAppMiniInbox
            preselectPhone={lead.phone}
            preselectName={lead.name}
            preselectLeadId={lead.id}
            height="100%"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
